module.exports = __webpack_public_path__ + "static/falling-coins-wide-a258c70136a623396d52ec792dbbde89.jpg";